export default {"src":"/_next/static/media/mail.cedf0d1c.svg","height":268,"width":395};